"use client";

import { AppShell, Burger, Group } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { OrganizationProvider } from "@/context/OrganizationContext";
import { Sidebar } from "../ui/sidebar";
import { useState } from "react";

const Layout: React.FunctionComponent<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [opened, setOpened] = useState(false);

  const closeSidebar = () => setOpened(false);

  const toggle = () => {
    setOpened((prev) => !prev);
  };

  const isMobile = useMediaQuery("(max-width: 768px)");

  return (
    <OrganizationProvider>
      <AppShell
        navbar={{
          width: "300px",
          breakpoint: "sm",
          collapsed: { mobile: !opened },
        }}
        padding="sm"
        layout="alt"
      >
        <AppShell.Navbar>
          <Sidebar opened={opened} toggle={toggle} onNavigate={closeSidebar} />
        </AppShell.Navbar>
        <AppShell.Main style={{ backgroundColor: "#0D0D0D" }}>
          {isMobile && (
            <Group h={44} align="center" mb="md">
              <Burger
                opened={opened}
                onClick={toggle}
                size="sm"
                aria-label="Toggle navigation"
              />
            </Group>
          )}
          {children}
        </AppShell.Main>
      </AppShell>
    </OrganizationProvider>
  );
};

export default Layout;
